import React, { useEffect, useCallback } from "react";
import { observer } from "mobx-react-lite";

import "./DamagesTable.scss";
import DataGrid from "../../../components/datatable/DataGrid";
import { DamagesStorage } from "../../../services/damage/DamagesStorage";
import { Damage } from "../../../services/damage/Damage";
import { videoPlayerService } from "../../../services/video-player/VideoPlayerService";

interface DamagesTableProps {
  damagesStorage: DamagesStorage;
}

export default observer((props: DamagesTableProps) => {
  const { damagesStorage } = props;
  const { setCurrentTimestampById } = videoPlayerService;

  const updatePlayerState = useCallback(
    (timestampId: number) => setCurrentTimestampById(timestampId),
    [setCurrentTimestampById]
  );

  useEffect(() => {
    if (props.damagesStorage.data) {
      props.damagesStorage.data.items.forEach((d: Damage) => {
        d.videoPositionOnClick(updatePlayerState);
      });
    }
    props.damagesStorage.handleCollapse(true);
  }, [props.damagesStorage, props.damagesStorage.data, updatePlayerState]);

  return (
    <div className={`damages-container ${props.damagesStorage.isCollapsed ? "collapsed" : ""}`}>
      <DataGrid
        itemTypeKey="general.damages"
        dataGridStorage={damagesStorage}
        singleSelection
        isOnSide
        isCollapsible
      />
    </div>
  );
});
